import Page from './page';
import { RouterConfig } from 'router/AppRoute';
import paths from 'helper/pathRoutes';

const routes: RouterConfig[] = [
  {
    path: paths.user_group_manager,
    page: Page,
  },
];

export default routes;
